import { ReactElement, useEffect } from "react";
import { v4 } from "uuid";
import { create } from "zustand";
import styles from "./async_modal_popup.module.css";
import { EachModalPopup } from "./each_modal_popup";
import useTrackingManager from "@Hooks/tracking/use_tracking_manger";

export default function AsyncModalPopupManager() {
  const { modalPopupContents, removeModalPopupById } =
    useModalPopupStoreInternal();
  const shouldShow = modalPopupContents.length > 0;
  const { trackPopupClose, trackButtonClick } = useTrackingManager();

  return (
    <>
      {modalPopupContents.map((eachContent, contentIndex) => {
        const anchor = eachContent.content.anchor ?? "center";

        return (
          <EachModalPopup
            key={eachContent.removalId}
            hidden={eachContent.content.hidden ?? false}
            anchor={anchor}
            eachContent={eachContent}
            contentIndex={contentIndex}
            removeModalPopupById={(removeId) => {
              trackPopupClose();
              removeModalPopupById(removeId);
            }}
          />
        );
      })}
      <div
        onClick={() => {
          trackButtonClick("닫기");
          trackPopupClose();
          if (modalPopupContents.length === 0) {
            return;
          }

          const popup = modalPopupContents.at(modalPopupContents.length - 1);
          const removalId = popup?.removalId;
          if (removalId !== undefined && popup !== undefined) {
            const isAccept = popup.content.decisionHandler?.(-1) ?? true;

            if (isAccept === false) {
              return;
            }

            popup.resolver(-1);
            removeModalPopupById(removalId);
          }
        }}
        className={styles.dimLayer}
        style={{
          opacity: shouldShow ? "50%" : "0%",
          pointerEvents: shouldShow ? "all" : "none",
        }}
      />
    </>
  );
}

export interface ModalPopupUIProps {
  title?: string | ReactElement;
  trackTitle?: string;
  description?: string | ReactElement;
  buttonTitles?: (string | ReactElement)[];
  trackButtonTitles?: (string)[];
  buttonStackDirection?: "row" | "column";
  anchor?: "center" | "bottom";
  decisionHandler?: (clickedIndex: number) => boolean;
  hidden?: boolean;
  buttonWidth?: string;
  buttonGap?: number;
  showCloseButton?: "topRight";
  isSecondButtonColored?: boolean;
  topPadding?: number;
  customVerticalGaps?: [
    number | undefined,
    number | undefined,
    number | undefined,
    number | undefined,
  ];
  customHeight?: number;
  buttonBorderRadius?: number;
}

interface ZModalPopupInfo {
  modalPopupContents: {
    removalId: string;
    content: ModalPopupUIProps;
    resolver: (clickedButtonIndex: number) => void;
  }[];
  setModalPopupContent: (
    removalId: string,
    content: ModalPopupUIProps
  ) => Promise<number>;
  removeModalPopupById: (removalId: string) => void;
}

export function useModalPopup() {
  const { setModalPopupContent } = useModalPopupStoreInternal();
  
  return {
    setModalPopupContent: (content: ModalPopupUIProps) => {
      return setModalPopupContent(v4(), content);
    },
  };
}

export const useModalPopupStoreInternal = create<ZModalPopupInfo>((set) => ({
  modalPopupContents: [],
  asyncActions: [],
  
  setModalPopupContent: (removalId, content) => {
    const promise = new Promise(
      (
        resolve: (clickedButtonIndex: number) => void,
        reject: (reason: string) => void
      ) => {
        set((state) => ({
          ...state,
          modalPopupContents: [
            ...state.modalPopupContents,
            {
              removalId,
              content,
              resolver: resolve,
            },
          ],
        }));
      }
    );

    return promise;
  },
  removeModalPopupById: (removalId) => {
    set((state) => {
      let newState = {
        ...state,
      };

      let found = newState.modalPopupContents.find(
        (each) => each.removalId === removalId
      );
      if (found) {
        found.content.hidden = true;
      }

      return newState;
    });

    setTimeout(() => {
      set((state) => {
        const filtered = state.modalPopupContents.filter(
          (each) => each.removalId !== removalId
        );

        return {
          ...state,
          modalPopupContents: filtered,
        };
      });
    }, 300);
  },
}));
